import { Box } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import { WET_SIGN_REQUIRED_MESSAGE } from './wetSignConstants';

export const WetSignRequiredNotice = () => {
  return (
    <Box mb={2}>
      <Alert severity="warning">{WET_SIGN_REQUIRED_MESSAGE}</Alert>
    </Box>
  );
};

export default WetSignRequiredNotice;
